/**
 * Nombre canónico del usuario.
 *
 * La fuente de verdad es Firestore users/{uid}['Nombre completo'] (es lo que
 * edita el admin en el módulo de Usuarios). El displayName de Firebase Auth
 * es una copia desnormalizada que solo se escribe al CREAR el usuario, así
 * que queda obsoleta tras un cambio de nombre — nunca confiar en ella si el
 * doc de Firestore está disponible.
 */

export const canonicalUserName = (userDocData, authUser) => {
  const docName = userDocData?.['Nombre completo'];
  if (typeof docName === 'string' && docName.trim()) return docName.trim();
  return authUser?.displayName || authUser?.email || authUser?.uid || null;
};

/**
 * Re-sincroniza el displayName del perfil de Auth con el nombre canónico.
 * Best-effort: un fallo aquí no debe romper el login del usuario.
 *
 * @returns {Promise<boolean>} true si actualizó el perfil
 */
export const syncAuthDisplayName = async (authUser, name) => {
  if (!authUser || !name || authUser.displayName === name) return false;
  try {
    await authUser.updateProfile({ displayName: name });
    return true;
  } catch (e) {
    console.warn('[user_name] No se pudo sincronizar displayName:', e?.message);
    return false;
  }
};
